import React, { useEffect, useState } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { FaChevronLeft } from 'react-icons/fa';
import { toast } from 'react-toastify';
import BuyerRequirementDetailView from '../../components/infrastructureLeasing/BuyerRequirementDetailView';
import { fetchMyInfrastructureRequirementByIdAPI } from '../../services/infrastructureLeasingListing.service';
import 'bootstrap/dist/css/bootstrap.min.css';
import '../../assets/styles/infrastructure_leasing_buyer_requirements.scss';

export default function InfrastructureLeasingBuyerRequirementDetailPage() {
  const { requirementId } = useParams();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [detail, setDetail] = useState(null);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      setLoading(true);
      try {
        const res = await fetchMyInfrastructureRequirementByIdAPI(requirementId);
        if (cancelled) return;
        if (res?.success === false || !res?.data?.form) {
          toast.error(res?.message || 'Requirement not found.');
          navigate('/infrastructure-leasing/my-requirements', { replace: true });
          return;
        }
        setDetail(res.data);
      } catch (e) {
        if (!cancelled) {
          toast.error(e?.response?.data?.message || e?.message || 'Could not load requirement.');
          navigate('/infrastructure-leasing/my-requirements', { replace: true });
        }
      } finally {
        if (!cancelled) setLoading(false);
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [requirementId, navigate]);

  if (loading) {
    return (
      <div className="container-fluid py-4 ile-buyer-req">
        <p className="text-muted">Loading…</p>
      </div>
    );
  }

  if (!detail) {
    return null;
  }

  return (
    <div className="container-fluid py-4 ile-buyer-req ile-buyer-req-detail">
      <Link to="/infrastructure-leasing/my-requirements" className="btn btn-link btn-sm text-decoration-none ps-0 mb-2">
        <FaChevronLeft className="me-1" aria-hidden />
        My requirements
      </Link>

      <BuyerRequirementDetailView detail={detail} />
    </div>
  );
}
